/**
 * @file queue.provider.tsx
 * @description Провайдер компонента очереди для Task Manager приложения, который обеспечивает интеграцию контекста поиска с основным компонентом очереди. Выступает в роли обертки высшего порядка (HOC) для предоставления SearchTextContext всем дочерним компонентам очереди, обеспечивая централизованное управление состоянием поискового запроса и его синхронизацию между элементами интерфейса.
 * @author AI-Generated | Human-Reviewed
 * @created 2025-01-15
 * @updated 2025-01-15
 * @dependencies ['@features/catalog/context/search-text-context', './queue.component']
 * @related-files ['src/features/queue/queue.component.tsx', 'src/features/queue/index.js', 'src/features/catalog/context/search-text-context.tsx']
 */

import { SearchTextProvider } from '@features/catalog/context/search-text-context';
import { Queue as QueueMain } from './queue.component';

export const Queue = (props: any) => {
    return (
        <SearchTextProvider>
            <QueueMain {...props} />
        </SearchTextProvider>
    );
};